import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../../../actions/initActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class Label extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isVisible: false,
        };
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.onHideComplete = this.onHideComplete.bind(this);
        this.setContainerClass = this.setContainerClass.bind(this);
        this.setClass = this.setClass.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.doHide && this.state.isVisible) {
            this.hide();
        }
    }

    show() {
        let objectRef = this.objectRef.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: null
        };
        animationHelper.showHeight(params);
    }


    hide() {
        let objectRef = this.objectRef.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: null
        };
        animationHelper.hideHeight(params);
    }

    onHideComplete() {
        this.setState({isVisible: false});
    }


    setContainerClass() {
        if (appHelper.isDefined(this.props.container_class_name)) {
            return this.props.container_class_name;
        } else {
            return `object-container`;
        }

    }

    setClass() {
        if (appHelper.isDefined(this.props.class_name)) {
            return this.props.class_name;
        } else {
            return "";
        }
    }

    render() {

        return (
            <div className={`a-c`} ref={this.objectRef}>
                <div className={`${this.setContainerClass()}`}>
                    <div className={`${this.setClass()}`}>
                        <div>{this.props.text}</div>
                    </div>
                </div>
            </div>

        );
    }
}

Label.propTypes = {
    screenObject: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    class_name: PropTypes.string,
    doHide: PropTypes.bool,
    container_class_name: PropTypes.string,
};

Label.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Label);



/** WEBPACK FOOTER **
 ** ./src/components/objects/text/Label.js
 **/